import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import LocalisedMessage from 'components/Common/LocalisedMessage';
import { redirectToLogin } from 'actions/auth/redirectToLogin';

import ErrorPage from 'components/Errors/ErrorPage';

import { timeOutSession } from 'actions/app';

const SessionTimeoutError = ({ intl, dispatch, titleTextId, buttonTextId }) => {
  useEffect(() => {
    dispatch(timeOutSession());
  }, []);

  const onClick = () => {
    const actionUrl = intl?.messages?.sessionTimeoutActionUrl;
    if (actionUrl) {
      window.location = actionUrl;
      return;
    }
    redirectToLogin();
  };

  return (
    <ErrorPage
      title="You have been logged out"
      titleTextId={ titleTextId }
      showButton
      buttonText="Log In"
      buttonTextId={ buttonTextId }
      onButtonClick={ () => onClick() }
      type="server"
    >
      <LocalisedMessage id="sessionTimeout.content" />
    </ErrorPage>
  );
};

SessionTimeoutError.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    messages: PropTypes.shape().isRequired
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  titleTextId: PropTypes.string,
  buttonTextId: PropTypes.string
};

SessionTimeoutError.defaultProps = {
  titleTextId: 'sessionTimeout.title',
  buttonTextId: 'sessionTimeout.buttonText'
};

const mapDispatchToProps = dispatch => ({ dispatch });

export default injectIntl(connect(
  null,
  mapDispatchToProps
)(SessionTimeoutError));
